import BaseService from "./BaseService"
import BaseFilter from './BaseFilter';

export class CountryService extends BaseService{
	constructor() {
		super('/Country');
	}

	public getAllByFilter(filter: CountryFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class CountryFilter extends BaseFilter{
	constructor(countryAlpha?: string | null) {
		super();
	
		this._countryAlpha = countryAlpha;
		
	}

	private _countryAlpha?: string | null;
	

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._countryAlpha != null ? { CountryAlpha: this._countryAlpha } : {})
	
		);

		return data;
	};
}